// removed by extract-text-webpack-plugin
module.exports = {"headBanner":"_2HkI","opened":"_10Kz","sheadBanner":"_3ryD","showAllLink":"OdxO","backdrop":"_2pQx","arrowDown":"_2Hav","sarrowDown":"_16nr","frame":"_3Zko","closed":"_5k39","swipeable":"aN9g","dotnav":"QEYc","activeDot":"_1Hc1","inactiveDot":"_2Xo9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/dropslider/style.css
// module id = 366
// module chunks = 9